'use strict';

export default class {

    /*@ngInject*/
    constructor($http, ARTICULO_CATEGORIA_URL, ARTICULOS_URL, UTIL_URL){
        Object.assign(this, {$http, ARTICULO_CATEGORIA_URL, ARTICULOS_URL, UTIL_URL});
    }

    getArticulosPorCategoria(categoria){
        return this.$http.get(this.ARTICULO_CATEGORIA_URL + '/' + categoria);
    }

    getArticulosPorSubcategoria(categoria, subcategoria){
        return this.$http.get(this.ARTICULO_CATEGORIA_URL + '/' + categoria + '/' + subcategoria);
    }

    getArticuloPorCodigo(codigo) {
        return this.$http.get(this.ARTICULOS_URL + '/' + codigo);
    }

    getArticulosPorCodigo(codigo){
        return this.$http.get(this.ARTICULOS_URL + '/codigo/' + codigo);
    }

    getArticulosPorPalabraClave(palabra){
        return this.$http.get(this.ARTICULOS_URL + '/palabra/' + palabra);
    }

    getArticuloCategorias(){
        return this.$http.get(this.UTIL_URL + '/categorias');
    }

    crearArticulo(articulo){
        return this.$http.post(this.ARTICULOS_URL, articulo);
    }

    actualizarArticulos(lista){
        return this.$http.put(this.ARTICULOS_URL + '/lista', lista);
    }
    mostrarPrecios(){
        return this.$http.put(this.ARTICULOS_URL + '/precios/mostrar');
    }
    ocultarPrecios(){
        return this.$http.put(this.ARTICULOS_URL + '/precios/ocultar');
    }

    editarArticulo(articulo){
        return this.$http.post(this.ARTICULOS_URL + '/' + articulo._id, articulo);
    }

    getSubcategoriasPorCategoria(categoria){
        return this.$http.get(this.UTIL_URL + '/categorias/' + categoria + '/subcategorias');
    }
}



// WEBPACK FOOTER //
// ./client/components/articulo/articulo.service.js